<template>
    <div>
        <van-nav-bar
                :title="site.site_name"
                left-text="预览"
                @click-left="onClickLeft"
        >
            <a :href="'http://'+site.id+'.'+siteDomain" slot="left"><i  class="iconfont">&#xe612;<span class="yulan">预览</span></i></a>
        </van-nav-bar>
        <div class="container">
            <van-row>
                <van-col span="24">
                    <van-cell-group>
                        <van-cell class="stats">
                            <h1>今日浏览次数PV</h1>
                            <div class="today-money">{{orderInfo.todayMoney||0.00}}</div>
                        </van-cell>
                    </van-cell-group>
                </van-col>
            </van-row>
            <van-row class="row-margin">
                <van-col span="12">
                    <van-cell-group>
                        <router-link to="/mobile/order/list?status=20"><van-cell>独立访客UV <span>{{orderInfo.waitShipCount}}</span></van-cell></router-link>
                    </van-cell-group>
                </van-col>
                <van-col span="12">
                    <van-cell-group>
                        <router-link to="/mobile/order/list?status=35"><van-cell>IP <span>0</span></van-cell></router-link>
                    </van-cell-group>
                </van-col>
            </van-row>

            <van-row class="row-margin">
                <van-col span="6" class="text-center"><router-link to="/mobile/nav/index" class="guanli-a"><i class="iconfont icon-dianpuguanli"></i><p>网站栏目</p></router-link></van-col>
                <van-col span="6"><router-link to="/mobile/article/index" class="guanli-a"><i class="iconfont icon-shangpinguanli"></i><p>文章管理</p></router-link></van-col>
                <van-col span="6"><router-link to="/mobile/order/list" class="guanli-a"><i class="iconfont icon-dingdan"></i><p>模板管理</p></router-link></van-col>
                <van-col span="6"><router-link to="/mobile/member/index" class="guanli-a"><i class="iconfont icon-user"></i><p>数据统计</p></router-link></van-col>
            </van-row>

            <van-tabbar v-model="active">
                <van-tabbar-item icon="shop" :to="'/mobile/index?siteId='+siteId">站点</van-tabbar-item>
                <van-tabbar-item icon="contact" to="/mobile/site/index">站点列表</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>

</template>

<script>
    import {Row,Col,Cell,CellGroup,Tabbar,TabbarItem,NavBar,Icon,Toast} from 'vant'
    import Cookies from 'js-cookie'
    export default {
        name: "index",
        components:{
            [Row.name]:Row,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Col.name]:Col,
            [Tabbar.name]:Tabbar,
            [TabbarItem.name]:TabbarItem,
            [NavBar.name]:NavBar,
            [Icon.name]:Icon,
            [Toast.name]:Toast
        },
        data(){
            return {
                active:0,
                icon: {
                    normal: 'static/images/icon-applications-normal.png',
                    active: 'static/images/icon-applications-active.png'
                },
                memberUrl:this.loginDomain+'/jz/#/',
                site:{},
                orderInfo:{},
                user_id:0,
                siteId:0
            }
        },
        created(){
            this.siteId = this.$route.query.siteId;
            Cookies.set('siteId',this.siteId);
            this.getStoreInfo(this.siteId);
        },
        methods:{
            onClickLeft() {
                this.$router.push('/mobile')
            },
            getStoreInfo(siteId){
                var _this = this;
                this.user_id = Cookies.get('user_id');
                //console.log(this.user);
                this.$http.get('/v1/sites/view',{params:{siteId:siteId}}).then((res)=>{
                    if (res.data.errcode == 1){
                        Toast("站点不存在，请创建站点");
                        _this.$router.push('/mobile/site/create')
                    }else {
                        _this.site = res.data.result;
                        //var storeId = sessionStorage.getItem('storeId');
                        //this.getOrderStatistics();
                    }
                })
            },
            getOrderStatistics(){
                var _this = this;
                this.$http.get('/v1/order/order-statistics',{params:{storeId:this.store.id}}).then((res)=>{
                    _this.orderInfo = res.data;
                })
            }
        }
    }
</script>

<style scoped>
    body{
        background: #f6f6f6;
    }
    a {
        color: #484848;
    }
    .container{
        padding: 15px;
    }
    .stats{
        background: #ff4444;
        font-size: 14px;
        color: #fff;
    }
    .stats h1{
        font-size: 14px;
        color: #fff;
    }
    .today-money{
        margin: 10px 0 0 0;
        color: #fff;
        font-size: 30px;
    }
    .row-margin{
        margin: 20px 0 0 0;
    }
    .text-center{
        text-align: center;
    }
    .icon-dianpuguanli, .icon-shangpinguanli,.icon-dingdan, .icon-user,.icon-shujutongji,.icon-qianbao{
        font-size: 30px;
        width: 100%;
        color: #ff4444;
    }
    .guanli-a{
        display: block;
    }
    .van-col{
        text-align: center;
    }

    @font-face {
        font-family: 'iconfont';  /* project id 701431 */
        src: url('//at.alicdn.com/t/font_701431_ht4mt2zti9q.eot');
        src: url('//at.alicdn.com/t/font_701431_ht4mt2zti9q.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_701431_ht4mt2zti9q.woff') format('woff'),
        url('//at.alicdn.com/t/font_701431_ht4mt2zti9q.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_701431_ht4mt2zti9q.svg#iconfont') format('svg');
    }
    .van-icon {
        font-family: 'vant-icon', 'custom-iconfont' !important;
    }
    .van-icon-extra:before {
        content: '\e626';
    }
    .yulan{
        font-size: 14px;
    }
</style>
